import { VideoPlayer } from "../VideoPlayer.js";

export type VideoPlayerButtonIcon<States extends string> = { [K in States]: string };

export abstract class VideoPlayerButton<IconState extends string = string> {
    public element: HTMLDivElement;
    public position: "left" | "right" = "left";
    public abstract icons: VideoPlayerButtonIcon<IconState>;

    private _iconState: IconState = null;
    private _icon: HTMLDivElement;

    constructor(protected _player: VideoPlayer) {
        this.element = document.createElement("div");
        this.element.className = "e5-video-player__button";
        this.element.innerHTML = `<div class="e5-video-player__button-icon"></div>`;
        this._icon = this.element.querySelector(".e5-video-player__button-icon");

        this.element.addEventListener("click", () => {
            this.click();
        });
    }

    protected abstract click(): void;

    public abstract create(): void;

    public get supported(): boolean {
        return true;
    }

    protected get iconState(): IconState {
        return this._iconState;
    }

    protected set iconState(iconState: IconState) {
        if (this._iconState === iconState)
            return;
        if (this._iconState) {
            this._icon.classList.remove.apply(this._icon.classList, this.icons[this._iconState].split(" "));
        }
        this._iconState = iconState;
        if (this._iconState) {
            this._icon.classList.add.apply(this._icon.classList, this.icons[this._iconState].split(" "));
        }
    }

    public get active(): boolean {
        return this.element.classList.contains("e5-video-player__button--active");
    }

    public set active(active: boolean) {
        this.element.classList.toggle("e5-video-player__button--active", active);
    }
}